<template>
  <div class="font-opensans cat-page">

    <div class="cat-header">
      <div class="cat-header-title">
        <b-icon icon="tags" font-scale="1.1"></b-icon>
        <span>Alta de Tipo de Producto</span>
      </div>
      <b-button class="cat-header-back" @click="goBack()">
        <b-icon icon="arrow-left"></b-icon> Regresar
      </b-button>
    </div>

    <div class="cat-form-card">
      <b-form @submit.prevent="guardarTipoProducto">
        <!-- Descripción del tipo de producto -->
        <b-row>
          <b-col cols="12" md="6">
            <b-form-group label="Descripción:" label-for="descripcion" class="pt-2 pb-3">
              <b-form-input
                id="descripcion"
                v-model="tipoProducto.descripcion"
                maxlength="75"
                required
                placeholder="Ingrese la descripción del tipo de producto"
                class="shadow-sm"
              />
            </b-form-group>
          </b-col>
        </b-row>
  
        <!-- Botones de acción -->
        <b-row>
          <b-col>
            <b-button class="cat-back-btn me-2" @click="goBack()"><b-icon icon="arrow-left"></b-icon> Regresar</b-button>
            <b-button type="submit" class="cat-save-btn"><b-icon icon="check2"></b-icon> Guardar</b-button>
          </b-col>
        </b-row>
      </b-form>
      <Modals ref="mod"></Modals>
    </div>
  </div>
  </template>
  
  <script>
  import Modals from '@/components/Modals.vue'
  import {mapState,mapActions} from 'vuex'
  import * as utils from "@/shared/util"
  export default {
    data() {
      return {
        texto:"Tipo de producto",
        cargando:false,
        tipoProducto: {
          tipo_producto_id: null,
          descripcion: ''
        },
        nuevo:true
      };
    },
    components: {
        Modals,
        // Operadores,
    },
    computed: {
      ...mapState(['operador','modal','menu']),
      // name() {
      //   return this.data 
      // }
    },
    // mounted() {
    //   this.setFechaActual();
    // }
    created() {
     
      console.log("el parametro enviado es: " , this.$route.params); // Accede al valor '123'
      if(this.$route.params.tipo_producto_id != undefined){
        this.tipoProducto=this.$route.params
        this.nuevo=false
      }
      
      // this.form.estatus=1
      console.log("Es nuevo :" + this.nuevo)
    },
    methods: {
      ...mapActions(['actupdateMenu','actupdateModal']),
      showmodal(tittle,message){
          this.modal.tittle = tittle
          this.modal.message = message
          this.modal.type = 0
          this.actupdateModal(this.modal)
          console.log("ahora contiene:  " + JSON.stringify(this.modal))
          this.$refs.mod.showmodal()
      },
      guardarTipoProducto() {
        // Lógica para guardar el tipo de producto
        console.log('Tipo de Producto guardado:', this.tipoProducto);
        this.cargando=true
       
        // return ""
        if(this.nuevo){
          console.warn('enviando :' + JSON.stringify(this.tipoProducto));
          this.$store.dispatch("createTipoProducto",this.tipoProducto).then((res)=>{
            console.log("dispatch createTipoProducto trajo: "+JSON.stringify(res))
            if(res.estatus==1){
              this.goBack()
            }else{
              this.showmodal(this.texto, res.message)
            }
          }).catch((error)=>{
            this.showmodal(this.texto, error)
            this.cargando=false
          })
        }else{
          console.warn('enviando :' + JSON.stringify(this.tipoProducto));
          this.$store.dispatch("updateTipoProducto",this.tipoProducto).then((res)=>{
            console.log("dispatch updateTipoProducto trajo: "+JSON.stringify(res))
            if(res.estatus==1){
              this.goBack()
            }else{
              this.showmodal(this.texto, res.message)
            }
          }).catch((error)=>{
            this.showmodal(this.texto, error)
            this.cargando=false
          })
        }
        
        this.cargando=false
      },
      goBack(){
        this.$router.go(-1)
      },
      // regresar() {
      //   // Lógica para regresar a la vista anterior
      //   this.$router.push('/');
      // }
    }
  };
  </script>

  <style scoped>
  @import "@/assets/css/app.css";

  .cat-page { min-height: 100vh; background: #f0f4f8; padding-bottom: 2rem; }
  .cat-header {
    display: flex; align-items: center; justify-content: space-between;
    background: linear-gradient(90deg, #0d2b5e 0%, #1a4d8f 60%, #316ea0 100%);
    padding: 0.75rem 1.5rem; color: #fff;
  }
  .cat-header-title { display: flex; align-items: center; gap: 0.5rem; font-size: 1.1rem; font-weight: 600; }
  .cat-header-back {
    background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.4);
    color: #fff; font-size: 0.85rem; border-radius: 6px; padding: 0.3rem 0.9rem;
  }
  .cat-header-back:hover { background: rgba(255,255,255,0.28); }
  .cat-form-card {
    background: #fff; border-radius: 0 0 12px 12px;
    box-shadow: 0 2px 12px rgba(13,43,94,0.08); padding: 1.5rem; margin: 0 1rem 1rem;
  }
  .cat-save-btn {
    background: linear-gradient(90deg, #0d2b5e, #1a4d8f); border: none;
    color: #fff; border-radius: 6px; padding: 0.4rem 1.2rem; font-weight: 600;
  }
  .cat-save-btn:hover { background: linear-gradient(90deg, #1a4d8f, #316ea0); }
  .cat-back-btn {
    background: transparent; border: 1px solid #6c757d;
    color: #6c757d; border-radius: 6px; padding: 0.4rem 1rem; font-weight: 600;
  }
  .cat-back-btn:hover { background: #6c757d; color: #fff; }
  @media (max-width: 576px) {
    .cat-header { padding: 0.6rem 1rem; }
    .cat-header-title { font-size: 1rem; }
    .cat-form-card { padding: 1rem 0.75rem; margin: 0 0.5rem 1rem; }
    .cat-save-btn, .cat-back-btn { width: 100%; margin-bottom: 0.5rem; }
  }
  </style>
